import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { EventService } from '../services/contract_event.service';
import { ContractService } from '../services/contract.service';
import { Contract_Event } from '../models/contract_event.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'contract_event',
  templateUrl: '../views/core/contract_event.html',
  providers: [EventService,ContractService]
})
export class EventComponent{
  public title: string;
  public contract_events: Contract_Event[];
  public submitcontract_eventModel: Contract_Event;
  public message: any;
  public mode: string;
  public privileges: Privileges[];
  public contractPrivilege:number;
  public wait:boolean;
  public tipo:string;
  public contract_id:number;
  public linkToPdf:string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private contract_eventService: EventService,
    public sharedVariables: VariableService,
    public contractService: ContractService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitcontract_eventModel = new Contract_Event(0,null,null,null,
                                                          null,null,null,null,null,null,null,null,null);
      this.contractPrivilege = null;
      this.wait = true;
      this.tipo = "UTILIZADO";
      this.linkToPdf= null;
  }

  ngOnInit()
  {

    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getContractInformation();
                                    this.getAllcontract_events();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait = false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getContractInformation()
  {
    this._route.params.forEach((params: Params)=>{
      let id = params['contract_id'];
      this.contract_id = id;
      this.submitcontract_eventModel.Contract_ID = this.contract_id;
    });
    console.log(this.submitcontract_eventModel.Contract_ID);
  }

  getAllcontract_events()
  {
    this.contract_eventService.getContract_events(this.submitcontract_eventModel.Contract_ID).subscribe(
      result => {
        if(result.code != 200)
        {
          if(result.data == 'No encontrado')
          {
            this.contract_events = null;
          }
          console.log(result);

        }else{
          this.contract_events = result.data;
          console.log(this.contract_events);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }


  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.savecontract_event();
    }else{
      this.updatecontract_event();
    }

    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllcontract_events();
                      this.submitcontract_eventModel = new Contract_Event(0,null,null,null,
                                                                          null,null,null,null,null,null,null,null,null);
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  savecontract_event()
  {
    this.contract_eventService.addContract_event(this.submitcontract_eventModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  cleanObject()
  {
    this.submitcontract_eventModel = new Contract_Event(0,null,null,null,
                                                        null,null,null,null,null,null,null,null,null);
  }
  editcontract_event(pcontract_event: Contract_Event)
  {
    this.mode = "submit-update";
    this.submitcontract_eventModel = Object.assign({}, pcontract_event);

    console.log("Checkout objects");
    console.log("mode ",this.mode);
  }

  updatecontract_event()
  {
      let id = this.submitcontract_eventModel.ID;
      console.log("objeto update ",this.submitcontract_eventModel);
      this.contract_eventService.updateContract_event(id,this.submitcontract_eventModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }
  generateContract(service_id:number,id_contract:number,customer_id:number,report_name:string)
  {
    this.contractService.generateContract(service_id,id_contract,customer_id,report_name).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          setTimeout(()=> {
                           this.linkToPdf = result.data;
                           window.open(this.linkToPdf,'_blank');
                           console.log("link para el pdf",this.linkToPdf);
                         },this.sharedVariables.timeToReport);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  deletecontract_event(id: number)
  {
    console.log("Delete function number",id);
    this.contract_eventService.deleteContract_event(id).subscribe(
        response => {
          if(response.code == 200){
                this.getAllcontract_events();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  changemode()
  {
    this.tipo = this.submitcontract_eventModel.type;
    console.log("Tipo",this.tipo);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",this.contractPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/event.component.ts